/**
 * Platform layer — DENVORA Mobility / Pathway OS (ADR-018).
 * Fase 5 cutover: canonical origins on denvoramobility.* (2026-07-01).
 */
export const PRODUCT_BRAND = "DENVORA Mobility";
export const BRAND_NAME_PRIMARY = "DENVORA";
export const BRAND_NAME_SECONDARY = "MOBILITY";
export const LEGACY_BRAND = "GoldPortugal";
export const FUTURE_BRAND = "DENVORA Mobility";

/** User-facing platform label (avoid internal "Pathway OS" jargon on the site). */
export const PLATFORM_NAME = "International Residency Platform";

export function getPlatformName(lang: SiteLanguage): string {
  return lang === "en"
    ? "International Residency Platform"
    : "Plataforma de Residência Internacional";
}

/** Active production domains (Fase 5 cutover). */
export const SITE_ORIGINS = {
  en: "https://denvoramobility.com",
  pt: "https://denvoramobility.pt",
} as const;

/** @deprecated Use SITE_ORIGINS — kept for redirect map Camada B */
export const FUTURE_SITE_ORIGINS = SITE_ORIGINS;

/** Legacy domains — 301 → denvoramobility.* via vercel.json Camada B */
export const LEGACY_ORIGINS = {
  en: "https://goldportugal.com",
  pt: "https://goldportugal.pt",
} as const;

export type SiteLanguage = keyof typeof SITE_ORIGINS;

export const CONTACT_EMAILS = {
  /** Central Inovaro inbox (Resend + securemail) */
  info: "info@inovaro.pt",
  noreply: "noreply@denvoramobility.com",
  brandInfo: "info@denvoramobility.com",
  /** Legacy — keep until Resend/MX fully cut over */
  legacyInfo: "info@goldportugal.com",
  legacyNoreply: "noreply@goldportugal.com",
} as const;

/** Public contact phone — used in schema, footer, and contact links */
export const CONTACT_PHONE = {
  display: "+351 912 345 678",
  e164: "+351912345678",
  whatsapp: "351912345678",
} as const;

/** Registered company address — single source of truth for footer, contact, and legal pages */
export const COMPANY_ADDRESS = {
  line1: "Rua Doutor Cândido Pinho, 28 – 2.º Ap. 21",
  line2: "4520-211 Santa Maria da Feira",
  full: "Rua Doutor Cândido Pinho, 28 – 2.º Ap. 21, 4520-211 Santa Maria da Feira",
} as const;

export function getBrandTitle(lang: SiteLanguage): string {
  return lang === "en"
    ? `${PRODUCT_BRAND} | International Residency Intelligence`
    : `${PRODUCT_BRAND} | Inteligência de Residência Internacional`;
}

export function getBrandDescription(lang: SiteLanguage): string {
  return lang === "en"
    ? "Relocation tools, visa pathways, and concierge for global citizens across Portugal, Spain, Italy, and Greece—with curated licensed partner introductions."
    : "Ferramentas de relocalização, vistos e concierge para cidadãos globais em Portugal, Espanha, Itália e Grécia—com encaminhamento a parceiros licenciados.";
}

export function getSiteOrigin(lang: SiteLanguage): string {
  return SITE_ORIGINS[lang];
}

export function getOgImageUrl(lang: SiteLanguage = "pt"): string {
  return `${SITE_ORIGINS[lang]}/og-image.png`;
}

/** Public URL for header/footer (PNG with brand lockup) */
export const BRAND_LOGO_URL = "/denvora-mobility-logo.png";
export const BRAND_SYMBOL_URL = "/denvora-symbol.png";

/** Cal.com — marcação DENVORA Mobility */
export const CAL_BASE_URL = "https://app.cal.eu";
export const CAL_USERNAME = "denvora";
export const CAL_EVENT_MOBILITY = "denvora-mobility";
export const CAL_BOOKING_URL_MOBILITY = `${CAL_BASE_URL}/${CAL_USERNAME}/${CAL_EVENT_MOBILITY}`;
